import { NgModule, Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "replacePercent",
})
export class ReplacePercentPipe implements PipeTransform {
    public transform(sentence: string, value: string | undefined): string {
        if (value === undefined) {
            return sentence;
        }
        return sentence.replace("%s", `${value}`);
    }
}

@NgModule({
    declarations: [ReplacePercentPipe],
    exports: [ReplacePercentPipe],
    providers: [ReplacePercentPipe],
})
export class ReplacePercentPipeModule {}
